import { Helmet } from "react-helmet-async"
import { useParams } from "../../../../router-utils"
import { ServiceLocationDetails } from "../../../../TransportServices"
import { Outlet } from "react-router"

export default function ServiceLocationDetailsPage() {
	const { serviceLocationId } = useParams(
		"/transport-services/:serviceLocationId"
	)
	return (
		<>
			<Helmet>
				<title>Transport Service Details</title>
			</Helmet>
			<ServiceLocationDetails serviceLocationId={serviceLocationId}>
				{({ serviceLocation, onChange }) => (
					<Outlet context={{ serviceLocation, revalidate: onChange }} />
				)}
			</ServiceLocationDetails>
		</>
	)
}
